import { LogLevel } from '@azure/msal-browser';

export const msalConfig = (
  clientId = '',
  authorityBaseUrl = '',
  redirectUri = '',
  logoutUri = '',
  userFlow = '',
  tenantName = ''
) => {
  return {
    auth: {
      clientId: clientId, // This is the ONLY mandatory field that you need to supply.
      authority: `${authorityBaseUrl}${userFlow}`, // Choose SUSI as your default authority.
      knownAuthorities: [tenantName], // Mark your B2C tenant's domain as trusted.
      redirectUri: redirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
      postLogoutRedirectUri: logoutUri, // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: false, // If 'true', will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: 'sessionStorage', // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
      storeAuthStateInCookie: false, // Set this to 'true' if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        logLevel: import.meta.env.MSSAL_LOGGING_LEVEL ?? LogLevel.Verbose,
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        },
        piiLoggingEnabled: false,
      },
      windowHashTimeout: 60000,
      iframeHashTimeout: 6000,
      loadFrameTimeout: 0,
      asyncPopups: false,
    },
  };
};
